import { HttpErrorResponse } from '@angular/common/http';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../../services/auth.service';

@Component({
  selector: 'app-confirm-email-change',
  templateUrl: './confirm-email-change.component.html',
  styleUrl: './confirm-email-change.component.scss',
})
export class ConfirmEmailChangeComponent {
  loading = true;
  error = false;
  conflict = false;

  constructor(private router: Router, authService: AuthService) {
    const token = this.router.parseUrl(this.router.url).queryParams['token'];

    authService.confirmEmailChange(token).subscribe({
      next: () => {
        this.loading = false;
      },
      error: (err: HttpErrorResponse) => {
        this.loading = false;
        this.error = true;
        this.conflict = err.status === 409;
      },
    });
  }

  onLogin() {
    this.router.navigate(['/auth/login']);
  }
}
